import React, { useState } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import approvalService from '../../services/approvalService';
import projectService from '../../services/projectService';
import userService from '../../services/userService';
import './ApprovalCreate.css';
import taskService from '../../services/taskService';
import { FiEye, FiFile, FiLoader, FiTrash2, FiUpload, FiX } from 'react-icons/fi';

const ApprovalCreate = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [category, setCategry] = useState([]);
  const [users, setUsers] = useState([]);

  const [uploadQueue, setUploadQueue] = useState([]); // uploading files
  const [tempAttachments, setTempAttachments] = useState([]); // uploaded files
  const currentUpload = uploadQueue[0]; // If uploading one file at a time
  const [previewImage, setPreviewImage] = useState(null);
  const [showPreview, setShowPreview] = useState(false);
  const [taskId, setTaskId] = useState(null);
  const [attachments, setAttachments] = useState([]);


  const handlePreview = (url) => {
    console.log(url);
    setPreviewImage(url);
    setShowPreview(true);
  };

  const closePreview = () => {
    setShowPreview(false);
    setPreviewImage(null);
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);

    files.forEach((file) => {
      uploadFile(file);
    });

    e.target.value = "";
  };


  const uploadFile = async (file) => {
    const tempId = Date.now();

    setUploadQueue((prev) => [
      ...prev,
      {
        id: tempId,
        file,
        progress: 0,
      },
    ]);


    try {
      const res = await taskService.uploadTempAttatchment(
        file, taskId, 'tasks',
        (event) => {
          const progress = Math.round(
            (event.loaded * 100) / event.total
          );

          setUploadQueue((prev) =>
            prev.map((item) =>
              item.id === tempId
                ? { ...item, progress }
                : item
            )
          );
        }
      );

      setUploadQueue((prev) =>
        prev.filter((item) => item.id !== tempId)
      );

      const uploadedFileName =
        res.saved_file_resp.fileName.split("/").pop();

      setTempAttachments((prev) => [
        ...prev,
        {
          obj: res
        },
      ]);
      console.log("tesmpp", tempAttachments)
    } catch (error) {
      setUploadQueue((prev) =>
        prev.filter((item) => item.id !== tempId)
      );
    }
  };

  const removeAttachment = (id) => {
    setTempAttachments((prev) =>
      prev.filter((attachment) => attachment.id !== id)
    );
  };

  const getFileIcon = (type) => {
    if (type.startsWith('image/'));
    if (type === 'application/pdf');
    if (type.includes('word'));
    if (type.includes('excel') || type.includes('spreadsheet'));
    if (type.includes('zip') || type.includes('rar'));
    return <FiFile size={24} style={{ color: 'var(--color-text-secondary, #9ca3af)' }} />;
  };

  const formatBytes = (bytes) => {
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
  };


  const [formData, setFormData] = useState({
    title: '',
    description: '',
    approval_type: 'Other',
    priority: 'Medium',
    project_id: '',
    approver_id: '',
    requested_amount: '',
    due_date: '',
    is_urgent: false,
    approval_category: ''
  });

  const { data: projectsData } = useQuery({
    queryKey: ['projects'],
    queryFn: () => projectService.getAllProjects()
  });

  const { data: usersData } = useQuery({
    queryKey: ['users'],
    queryFn: () => userService.getAll()
  });

  const projects = projectsData?.projects || [];
  // const users = usersData?.users || [];

  const createMutation = useMutation({
    mutationFn: approvalService.createApproval,
    onSuccess: () => {
      queryClient.invalidateQueries(['approvals']);
      toast.success('Approval request created successfully');
      navigate('/app/approvals');
    },
    onError: (error) => {
      toast.error(error.response?.data?.error || 'Failed to create approval request');
    }
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };


  const handleProjectChange = async (e) => {
    const value = e.target.value;

    setFormData({ ...formData, [e.target.name]: e.target.value });

    try {
      console.log("Calling API for project:", value);

      const data = await approvalService.getApprovarsData(formData.project_id, value);
      setUsers(data.data || []);

      console.log("Milestones:", data);
    } catch (error) {
      toast.error("Milestones not found");
      console.error("API Error:", error);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate required fields
    if (!formData.title || !formData.approver_id) {
      toast.error('Please fill in all required fields');
      return;
    }

    const submitData = {
      ...formData,
      requested_amount: formData.requested_amount ? parseFloat(formData.requested_amount) : null,
      project_id: formData.project_id || null,
      due_date: formData.due_date || null
    };

    createMutation.mutate(submitData);
  };

  return (
    <div className="approval-create-page no-max-widt ">
      <div className="page-header">
        <h1>Create Approval Request</h1>
        <button className="btn btn-secondary" onClick={() => navigate('/app/approvals')}>
          <i className="fas fa-arrow-left"></i> Back
        </button>
      </div>

      <form onSubmit={handleSubmit} className="approval-form">

        <div className='grid md:grid-cols-2'>
          <div className="">
            <div className="form-section">
              <h3>Information</h3>

              <div className="form-group">
                <label htmlFor="title">Title *</label>
                <input
                  type="text"
                  id="title"
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                  required
                  placeholder="Enter approval title"
                />
              </div>

              <div className="form-group">
                <label htmlFor="description">Description</label>
                <textarea
                  id="description"
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  rows="4"
                  placeholder="Enter detailed description"
                />
              </div>

              <div className="grid md:grid-cols-2 custom-request">
                <div className="form-group">
                  <label htmlFor="approval_type">Approval Type *</label>
                  <select className='form-control'
                    id="approval_type"
                    name="approval_type"
                    value={formData.approval_type}
                    onChange={handleChange}
                    required
                  >
                    <option value="Budget">Budget</option>
                    <option value="Change Request">Change Request</option>
                    <option value="Document">Document</option>
                    <option value="Expense">Expense</option>
                    <option value="Project">Project</option>
                    <option value="Resource">Resource</option>
                    <option value="Risk">Risk</option>
                    <option value="Task">Task</option>
                    <option value="Time Off">Time Off</option>
                    <option value="Other">Other</option>
                  </select>
                </div>


                <div className="form-group">
                  <label htmlFor="priority">Priority *</label>
                  <select className='form-control'
                    id="priority"
                    name="priority"
                    value={formData.priority}
                    onChange={handleChange}
                    required
                  >
                    <option value="Low">Low</option>
                    <option value="Medium">Medium</option>
                    <option value="High">High</option>
                    <option value="Urgent">Urgent</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div className=" form-section ">
            <div className="form-group">
              <label htmlFor="project_id">Project</label>
              <select
                id="project_id"
                name="project_id"
                value={formData.project_id}
                onChange={handleChange}
              >
                <option value="">Select Project (Optional)</option>
                {projects?.map(project => (
                  <option key={project.id} value={project.id}>
                    {project.name}
                  </option>
                ))}
              </select>
            </div>            

            <div className="grid md:grid-cols-2 gap-4">
              <div className="form-group">
                <label htmlFor="approval_category">Approval Category *</label>
                <select
                  id="approval_category"
                  name="approval_category"
                  value={formData.approval_category}
                  onChange={handleProjectChange}
                  required
                >
                  <option value="">Select</option>
                  <option value="User">User</option>
                  <option value="Client">Client</option>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="approver_id">Approver *</label>
                <select
                  id="approver_id"
                  name="approver_id"
                  value={formData.approver_id}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Approver</option>
                  {users?.map(user => (
                    <option key={user.id} value={user.id}>
                      {user.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="grid md:grid-cols-2 custom-request">
              <div className="form-group">
                <label htmlFor="requested_amount">Requested Amount</label>
                <input
                  type="number"
                  id="requested_amount"
                  name="requested_amount"
                  value={formData.requested_amount}
                  onChange={handleChange}
                  step="0.01"
                  min="0"
                  placeholder="0.00"
                />
              </div>

              <div className="form-group">
                <label htmlFor="due_date">Due Date</label>
                <input
                  type="date"
                  id="due_date"
                  name="due_date"
                  value={formData.due_date}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="form-group checkbox-group">
              <label className='flex'>
                <input
                  type="checkbox"
                  name="is_urgent"
                  checked={formData.is_urgent}
                  onChange={handleChange}
                />
                <span>Mark as Urgent</span>
              </label>
            </div>
               
            <div className="text-center">
              <label htmlFor="file-upload" style={{ cursor: "pointer" }}>
                <input
                  id="file-upload"
                  type="file"
                  multiple
                  hidden
                  onChange={handleFileChange}
                />
                <button
                  type="button"
                  disabled={!!currentUpload}
                  onClick={() => !currentUpload && document.getElementById("file-upload").click()}
                  className="relative w-52 h-14 overflow-hidden disabled:cursor-default"
                >
                  {currentUpload && (
                    <span
                      className="absolute left-0 top-0 h-full bg-green-700 transition-all duration-200"
                      style={{ width: `${currentUpload.progress}%` }}
                    />
                  )}

                  <span
                    className="relative z-10 flex items-center h-full w-full text-white font-semibold text-lg"
                    style={{
                      paddingLeft: "3%",
                      gap: "12px",
                    }}
                  >
                    {currentUpload ? (
                      <>
                        <FiLoader className="animate-spin" size={20} />
                        <span>{currentUpload.progress}%</span>
                      </>
                    ) : (
                      <>
                        <>
                          <span
                            className="flex items-center justify-center rounded-full bg-white"
                            style={{
                              width: "40px",
                              height: "40px",
                              flexShrink: 0,
                            }}
                          >
                            <FiUpload size={20} className='text-blue-500' />
                          </span>
                        </>

                        <div>
                          <div className="text-blue-500 cursor-pointer">
                            Upload
                          </div>

                          <div className="text-xs text-red-500">
                            Note: Max file size 5MB
                          </div>
                        </div>
                      </>
                    )}
                  </span>
                </button>
              </label>
            </div>

            {Array.isArray(uploadQueue) && uploadQueue.length > 0 && (
              <ul className="tf-attachment-list mt-3">
                {uploadQueue.map((file) => {
                  if (!file?.file) return null;

                  return (
                    <li key={file.id} className="tf-attachment-item">
                      <span className="tf-attachment-file-icon">
                        {getFileIcon(
                          file?.file?.type || file?.file?.file_type
                        )}
                      </span>

                      <div className="tf-attachment-info" style={{ flex: 1 }}>
                        {file?.file?.name && (
                          <span className="tf-attachment-name">
                            {file.file.name}
                          </span>
                        )}

                        {file?.file?.size != null && (
                          <span className="tf-attachment-meta">
                            {formatBytes(file.file.size)}
                          </span>
                        )}
                      </div>
                    </li>
                  );
                })}
              </ul>
            )}

            {/* Uploaded Files */}
            {Array.isArray(tempAttachments) && tempAttachments.length > 0 && (
              <ul className="tf-attachment-list">
                {tempAttachments.map((attachment) => {
                  if (!attachment?.obj) return null;

                  return (
                    <li key={attachment.id} className="tf-attachment-item">
                      {(
                        attachment?.obj?.type ||
                        attachment?.obj?.file_type
                      ) && (
                          <span className="tf-attachment-file-icon">
                            {getFileIcon(
                              attachment?.obj?.type ||
                              attachment?.obj?.file_type
                            )}
                          </span>
                        )}

                      <div className="tf-attachment-info">
                        {attachment?.obj?.file_name && (
                          <span className="tf-attachment-name">
                            {attachment.obj.file_name}
                          </span>
                        )}
                      </div>

                      <div className="tf-attachment-actions">
                        {attachment?.obj?.file_full_path && (
                          <button
                            type="button"
                            className="tf-attachment-preview"
                            onClick={() =>
                              handlePreview(attachment.obj.file_full_path)
                            }
                            title="Preview"
                          >
                            <FiEye size={16} />
                          </button>
                        )}

                        <button
                          type="button"
                          className="tf-attachment-remove"
                          onClick={() => removeAttachment(attachment.id)}
                          title="Delete"
                        >
                          <FiTrash2 size={16} />
                        </button>
                      </div>
                    </li>
                  );
                })}
              </ul>
            )}



            {showPreview && (
              <div className="tf-preview-overlay" onClick={closePreview}>
                <div
                  className="tf-preview-modal"
                  onClick={(e) => e.stopPropagation()}
                >
                  <button
                    className="tf-preview-close"
                    onClick={closePreview}
                  >
                    <FiX size={22} />
                  </button>

                  <img
                    src={previewImage}
                    alt="Attachment Preview"
                    className="tf-preview-image"
                  />
                </div>
              </div>
            )}
          </div>

        </div>

        <div className="form-actions">
          <button type="button" className="btn btn-secondary" onClick={() => navigate('/app/approvals')}>
            Cancel
          </button>
          <button type="submit" className="btn btn-primary" disabled={createMutation.isLoading}>
            {createMutation.isLoading ? 'Creating...' : 'Create Approval Request'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default ApprovalCreate;


